import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TimeslotListVariantEnum } from '~/component/activity-timeslot-list/enums/timeslot-list-variant.enum';
import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { Activity } from '~/core/model/activity.model';
import { Timeslot } from '~/core/model/timeslot.model';
import { RedirectionService } from '~/core/services/redirection/redirection.service';

const NUMBER_OF_TIMESLOT_TO_DISPLAY = 4;

@Component({
  selector: 'app-organizer-shared-activity-timeslot-list',
  templateUrl: './activity-timeslot-list.component.html',
})
export class OrganizerSharedActivityTimeslotListComponent implements OnInit {
  @Input() public activity: Activity;
  @Input() public hasLoadMoreButton = false;
  @Input() public hasPagination = false;
  @Input() public hasSeeMoreUrl = false;
  @Input() public timeslots: Timeslot[] = [];

  @Output() public loadMore = new EventEmitter<void>();

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly timeslotVariant = TimeslotListVariantEnum.EXTENDED;
  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;

  constructor(private readonly redirectionService: RedirectionService) {}

  public ngOnInit(): void {
    this.timeslots = this.hasSeeMoreUrl
      ? this.timeslots.splice(0, NUMBER_OF_TIMESLOT_TO_DISPLAY)
      : this.timeslots;
  }

  public handleClick(timeslot: Timeslot): void {
    this.redirectionService.redirect(
      `/organizer.timeslot.manage/${timeslot.identifier}`
    );
  }
}
